module.exports = __webpack_public_path__ + "MaterialCommunityIcons.d15c1216.ttf";